import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';

import { srcOrNextImageProp } from 'PropTypes/imageProps';

import TextImage from 'Components/TextImage';

const useStyles = makeStyles(
  {
    root: {
      '& a': {
        color: '#ffa380',
        '& :hover': {
          color: '#ffa380',
        },
      },
    },
  },
  { name: 'Bcorp' }
);

const Bcorp = ({ content }) => {
  const classes = useStyles();

  const { description, imageDesktop, imageMobile, title } = content;

  return (
    <TextImage
      classes={{ blockContent: classes.root }}
      description={description}
      imageAlt="Photo of woman with text superimposed on it: better care for you hair - and the planet, Certified B Corporation logo"
      imageDesktop={imageDesktop}
      imageMobile={imageMobile}
      title={title}
      TitleProps={{ variant: 'h2r' }}
    />
  );
};

Bcorp.propTypes = {
  content: PropTypes.shape({
    description: PropTypes.node.isRequired,
    imageDesktop: srcOrNextImageProp.isRequired,
    imageMobile: srcOrNextImageProp.isRequired,
    title: PropTypes.string.isRequired,
  }).isRequired,
};

export default Bcorp;
